/*
 *  Links List - Create a list of links, and then share it!
 *  Copyright (c) Luke Denton
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation; either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export const VIEW_OPEN = 'open';
export const VIEW_DENSE = 'dense';

export const ALERT_SUCCESS = 'success';
export const ALERT_INFO = 'info';
export const ALERT_WARNING = 'warning';
export const ALERT_ERROR = 'error';

export const LIST_PERMISSION__PUBLIC = 'public';
export const LIST_PERMISSION__LOCKED = 'locked';
// export const LIST_PERMISSION__PRIVATE = 'private';
